<template>
  <section
    v-if="websiteId && pageId"
    id="comments-section"
    class="block no-print"
  >
    <div class="comments">
      <Comments
        :page-id="pageId"
        :settings="settings"
        :website-id="websiteId"
      />
    </div>
    <div class="page-content">
      <p v-if="!commentsHidden" class="text-center">
        All comments are moderated. Please visit our

        <a href="/about/terms-of-use"> terms of use </a>

        for guidance on how to engage with our community.
      </p>
    </div>
  </section>
</template>

<script setup lang="ts">
import * as hyvorPkg from '@hyvor/hyvor-talk-vue'
const { Comments } = hyvorPkg

type CommentsLayout = 'reactions-only' | null

const props = defineProps<{
  pageId: string | number
  layout?: CommentsLayout
}>()

const commentsHidden = computed(() => props.layout === 'reactions-only')

const customCss = computed(
  () =>
    `.reaction {filter:none} ${commentsHidden.value ? ' .main-box {display: none;}' : ''}`,
)

const {
  public: { hyvor },
} = useRuntimeConfig()
const websiteId = computed(() => hyvor.websiteId)

const settings = {
  custom_css: customCss.value,
}
</script>
